import { gql } from '@apollo/client'

export const CHECK_PIX_PAYMENT = gql`
  query CheckPixPayment($id: ID!) {
      checkPixPayment(id: $id)
    }

`
